import React, { useState, useEffect } from 'react';
import { Nav } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaHome, FaMap, FaChartBar, FaBell, FaUser, FaShareAlt, FaCar, FaEnvelope, FaCompass, FaDrawPolygon, FaMapMarkerAlt, FaSatelliteDish } from 'react-icons/fa';
import logo from '../images/logo.png';
import logo1 from '../images/logo1.png';

const Sidebar = ({ isOpen, activePage, onPageChange }) => {
  const [activeItem, setActiveItem] = useState('Home');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Set active item based on current path
    const path = location.pathname;
    if (path === '/') {
      setActiveItem('Home');
    } else if (path === '/reports') {
      setActiveItem('Reports');
    } else if (path === '/live-track') {
      setActiveItem('Live Track');
    } else if (path === '/map-rotate') {
      setActiveItem('Map Rotate');
    } else if (path === '/geofence') {
      setActiveItem('Geofence');
    } else if (path === '/landmarks') {
      setActiveItem('Landmarks');
    } else if (path === '/alerts') {
      setActiveItem('Alerts');
    } else if (path === '/sub-users') {
      setActiveItem('Sub Users');
    } else if (path === '/share-vehicle') {
      setActiveItem('Share Vehicle');
    } else if (path === '/vehicles') {
      setActiveItem('Vehicles');
    } else if (path === '/gps-devices') {
      setActiveItem('GPS Devices');
    } else if (path === '/contact') {
      setActiveItem('Contact Us');
    }
  }, [location]);

  const handleNavClick = (itemName, path) => {
    setActiveItem(itemName);
    if (onPageChange) {
      onPageChange(itemName);
    }
    // Don't change the sidebar state when navigating
    navigate(path);
  };

  return (
    <div className={`sidebar bg-white vh-100 border-end ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`} style={{ width: isOpen ? '240px' : '70px', transition: 'width 0.3s ease' }}>
      <div className="logo-container p-3 mb-4">
        {isOpen ? (
          <h4 className="text-primary fw-bold m-0 text-center mt-3">
            <img src={logo1} alt="Logo" className="img-fluid" style={{ maxWidth: '50%' }} />
          </h4>
        ) : (
          <div className="text-primary fw-bold text-center">
            <img src={logo} alt="Logo" className="img-fluid" style={{ maxWidth: '100%' }} />
          </div>
        )}
      </div>
      <Nav className="flex-column">
        <Nav.Link 
          className={`nav-item ${activeItem === 'Home' ? 'active' : ''}`}
          onClick={() => handleNavClick('Home', '/')}
        >
          <div className="icon-container"><FaHome /></div>
          {isOpen && <span className="nav-text">Home</span>}
        </Nav.Link>
        <Nav.Link 
          className={`nav-item ${activeItem === 'Live Track' ? 'active' : ''}`}
          onClick={() => handleNavClick('Live Track', '/live-track')}
        >
          <div className="icon-container"><FaMap /></div>
          {isOpen && <span className="nav-text">Live Track</span>}
        </Nav.Link>
        <Nav.Link 
          className={`nav-item ${activeItem === 'Map Rotate' ? 'active' : ''}`}
          onClick={() => handleNavClick('Map Rotate', '/map-rotate')}
        >
          <div className="icon-container"><FaCompass /></div>
          {isOpen && <span className="nav-text">Map Rotate</span>}
        </Nav.Link>
        <Nav.Link 
          className={`nav-item ${activeItem === 'Geofence' ? 'active' : ''}`}
          onClick={() => handleNavClick('Geofence', '/geofence')}
        >
          <div className="icon-container"><FaDrawPolygon /></div>
          {isOpen && <span className="nav-text">Geofence</span>}
        </Nav.Link>
        <Nav.Link 
          className={`nav-item ${activeItem === 'Landmarks' ? 'active' : ''}`}
          onClick={() => handleNavClick('Landmarks', '/landmarks')}
        >
          <div className="icon-container"><FaMapMarkerAlt /></div>
          {isOpen && <span className="nav-text">Landmarks</span>}
        </Nav.Link>
        <Nav.Link 
          className={`nav-item ${activeItem === 'Reports' ? 'active' : ''}`}
          onClick={() => handleNavClick('Reports', '/reports')}
        >
          <div className="icon-container"><FaChartBar /></div>
          {isOpen && <span className="nav-text">Reports</span>}
        </Nav.Link>
        <Nav.Link 
          className={`nav-item ${activeItem === 'Alerts' ? 'active' : ''}`}
          onClick={() => handleNavClick('Alerts', '/alerts')}
        >
          <div className="icon-container"><FaBell /></div>
          {isOpen && <span className="nav-text">Alerts</span>}
        </Nav.Link>
        <Nav.Link 
          className={`nav-item ${activeItem === 'Sub Users' ? 'active' : ''}`}
          onClick={() => handleNavClick('Sub Users', '/sub-users')}
        >
          <div className="icon-container"><FaUser /></div>
          {isOpen && <span className="nav-text">Sub Users</span>}
        </Nav.Link>
        <Nav.Link 
          className={`nav-item ${activeItem === 'Share Vehicle' ? 'active' : ''}`}
          onClick={() => handleNavClick('Share Vehicle', '/share-vehicle')}
        >
          <div className="icon-container"><FaShareAlt /></div>
          {isOpen && <span className="nav-text">Share Vehicle</span>}
        </Nav.Link>
        <Nav.Link 
          className={`nav-item ${activeItem === 'Vehicles' ? 'active' : ''}`}
          onClick={() => handleNavClick('Vehicles', '/vehicles')}
        >
          <div className="icon-container"><FaCar /></div>
          {isOpen && <span className="nav-text">Vehicles</span>}
        </Nav.Link>
        <Nav.Link 
          className={`nav-item ${activeItem === 'GPS Devices' ? 'active' : ''}`}
          onClick={() => handleNavClick('GPS Devices', '/gps-devices')}
        >
          <div className="icon-container"><FaSatelliteDish /></div>
          {isOpen && <span className="nav-text">GPS Devices</span>}
        </Nav.Link>
        <Nav.Link 
          className={`nav-item ${activeItem === 'Contact Us' ? 'active' : ''}`}
          onClick={() => handleNavClick('Contact Us', '/contact')}
        >
          <div className="icon-container"><FaEnvelope /></div>
          {isOpen && <span className="nav-text">Contact Us</span>}
        </Nav.Link>
      </Nav>
      <div className="mt-auto p-3">
        <img src="/map-illustration.png" alt="Map" className="img-fluid" style={{ maxWidth: '100%', opacity: 0.7 }} />
      </div>
    </div>
  );
};

export default Sidebar;